import type {
  ListResponse,
  ReplenishmentDraftPoInput,
  ReplenishmentDraftPoResult,
  ReplenishmentListMeta,
  ReplenishmentSuggestion,
} from '@warehouse/shared';

import { api } from '../../lib/api-client';
import { listQueryKey, listQueryParams, type ListState } from '../../lib/list-query';

export type ReplenishmentListResponse = ListResponse<ReplenishmentSuggestion> & {
  meta: ReplenishmentListMeta;
};

export const replenishmentKeys = {
  suggestions: (state: ListState) => ['replenishment', 'suggestions', listQueryKey(state)] as const,
} as const;

export const replenishmentApi = {
  suggestions: (state: ListState) =>
    api.get<ReplenishmentListResponse>('/replenishment/suggestions', {
      query: listQueryParams(state),
    }),
  createDraftPo: (body: ReplenishmentDraftPoInput) =>
    api.post<ReplenishmentDraftPoResult>('/replenishment/draft-po', {
      ...body,
      commandId: globalThis.crypto?.randomUUID?.(),
    }),
};
